export const convertStringToDataCy = (value: string): string => {
  return value.toLowerCase().replaceAll(":", "").replaceAll(" ", "-");
};
